
export const DataMenu = [
  {
    key: 'dashboard',
    name: 'My Dashboard',
    icon: 'home_Icon',
    link: '/dashboard',
  },
  {
    key: 'mycalendar',
    name: 'My Calendar',
    icon: 'today',
    link: '/mycalendar',
  },
  {
    key: 'myTeam',
    name: 'My Team',
    icon: 'group_work',
    link: '/myTeam/executiveSummary',
  },
  {
    key: 'timeSheet',
    name: 'Time Sheet',
    icon: 'hourglass_empty_icon',
    link: '/timeSheet',
  },
  {
    key: 'reports',
    name: 'Reports',
    icon: 'assessment',
    link: '/reports',
  },
  {
    key: 'screenshots',
    name: 'Screenshot',
    icon: 'airplay',
    link: '/screenshots/Lists',
  },
  {
    key: 'offlinetime',
    name: 'Offline Time',
    icon: 'tv_off',
    link: '/offlinetime/request',
  },
  {
    key: 'settings',
    name: 'Settings',
    icon: 'settings',
    link: '/settings',
  },

];
